import { jetbrainsMono, jetbrainsMonoChartFontFamily } from '@/theme/utils/font.utils';
import { cn } from '@/utils/shad';

/** Monospace styling for numeric readouts across Nebuly system pages. */
export const PAGE_DATA_NUMBER_CLASS = cn(jetbrainsMono.className, 'tabular-nums');

/** Large KPI headline numbers, at the scale and full-strength color of the AI Proficiency score. */
export const PAGE_KPI_NUMBER_CLASS = cn(
  PAGE_DATA_NUMBER_CLASS,
  'text-[44px] font-medium leading-none tracking-tight text-foreground',
);

/** Inline styles for Chart.js HTML tooltips (no Tailwind in external tooltip DOM). */
export const PAGE_DATA_NUMBER_INLINE_CSS = `font-family:${jetbrainsMonoChartFontFamily};font-variant-numeric:tabular-nums`;
